import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { ACCOUNTING_TRIAL_BALANCE_BASE_PATH } from '../../../../../../../../../features/accounting/trial-balance/accounting-trial-balance-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/trial-balance/_trial-balance')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'trial-balance',
        label: 'Accounting',
        to: ACCOUNTING_TRIAL_BALANCE_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
